export enum TextWordType {
  NOUN = "NOUN",
  VERB = "VERB"
}

export enum GNumber {
  SINGULAR = "sg",
  PLURAL = "pl",
  NULL = "NULL"
}

export enum GGender {
  F = "f",
  M = "m",
  N = "n",
  F_N = 'f_n',
  NULL = "NULL"
}

export enum GCase {
  NOM = "nom",
  GEN = "gen",
  DAT = "dat",
  ACC = "acc",
  INST = "inst",
  LOC = "loc",
  VOC = "voc"
}

export enum GTense {
  PAST_IMPERFECT = "PAST_IMPERFECT",
  PAST_PERFECT = "PAST_PERFECT",
  PRESENT = "PRESENT",
  FUTURE = "FUTURE",
  FUTURE_CONTINUOUS = "FUTURE CONTINUOUS",
  INF = "INF",
  INF_PERFECT = "INF_PERFECT",
}

export enum GMode {
  PERFECT = "PERFECT",
  CONTINUOUS = "CONTINUOUS"
}

export enum GPerson {
  PRI = "PRI",
  SEC = "SEC",
  TER = "TER",
}

export enum TenseCategory {
  PAST = 'PAST',
  PRESENT = 'PRESENT',
  FUTURE = 'FUTURE',
  INF = 'INF'
}

export interface TextWord {
  lemma: string;
  gCore: string;
  gNumber: GNumber;
  gGender: GGender;
}

export interface TextWordNoun extends TextWord {
  gCase: GCase;
  wordType: TextWordType.NOUN;
}

export interface TextWordVerb extends TextWord {
  tense: GTense;
  tenseCategory: TenseCategory;
  person: GPerson;
  wordType: TextWordType.VERB;
}

export enum GenderAndNumber {
  SG_PRI_M = "SG_PRI_M",
  SG_PRI_F = "SG_PRI_F",
  SG_SEC_M = "SG_SEC_M",
  SG_SEC_F = "SG_SEC_F",
  SG_TER_M = "SG_TER_M",
  SG_TER_F = "SG_TER_F",
  SG_TER_N = "SG_TER_N",
  PL_PRI_M = "PL_PRI_M",
  PL_PRI_F_N = "PL_PRI_F_N",
  PL_SEC_M = "PL_SEC_M",
  PL_SEC_F_N = "PL_SEC_F_N",
  PL_TER_M = "PL_TER_M",
  PL_TER_F_N = "PL_TER_F_N",
}
